import Requests from "@/services/Requests";

const state = {
  limit: 10,
  productCategories: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allProductCategories: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  productCategoryById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of productCategories based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter productCategories by. Defaults to 0.
   * @return {Array} An array of productCategories filtered by the given page number. If page is 0, returns all productCategories.
   */
  getProductCategories:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.productCategories.data
        : state.productCategories.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllProductCategories: (state) => state.allProductCategories.data,
  getProductCategoryStatus: (state) => state.productCategories.status,
  getProductCategoryCount: (state) => state.productCategories.count,
  getProductCategoryPage: (state) => state.productCategories.page,
  getProductCategoryPages: (state) =>
    Math.ceil(state.productCategories.count / state.limit),
  getProductCategoriesLoading: (state) =>
    state.productCategories.status === "loading",
  getProductCategoryById: (state) => (id) =>
    state.productCategoryById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the productCategory in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the productCategory.
   */
  SET_PRODUCT_CATEGORY_STATUS(state, payload) {
    console.log(state.productCategories, "status: ", payload);
    state.productCategories.status = payload;
  },
  /**
   * Sets the productCategories and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of productCategories.
   * @param {number} payload.count - The total count of productCategories.
   */
  SET_PRODUCT_CATEGORIES(state, payload) {
    state.productCategories.data = payload.items;
    state.productCategories.count = payload.count;
  },
  /**
   * Sets the productCategories and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of productCategories.
   * @param {number} payload.count - The total count of productCategories.
   */
  SET_ALL_PRODUCT_CATEGORIES(state, payload) {
    console.log("SET_ALL_PRODUCT_CATEGORIES", payload);
    state.allProductCategories.data = payload.items;
    state.allProductCategories.count = payload.count;
  },
  /**
   * Updates the status of the update productCategory in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the productCategory.
   */
  SET_UPDATE_PRODUCT_CATEGORY_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an productCategory object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated productCategory object.
   * @return {void}
   */
  SET_UPDATE_PRODUCT_CATEGORY(state, payload) {
    const index = state.productCategories.data.findIndex(
      (d) => d.id === payload.id
    );
    const productCategory = state.productCategories.data[index];
    state.productCategories.data[index] = { ...productCategory, ...payload };
  },
  SET_CREATE_PRODUCT_CATEGORY_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new productCategory to the list of productCategories in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The productCategory object to be added.
   * @return {void}
   */
  SET_CREATE_PRODUCT_CATEGORY(state, payload) {
    state.productCategories.data.push(payload);
  },
  /**
   * Updates the status of the delete productCategory in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the productCategory.
   */
  SET_DELETE_PRODUCT_CATEGORY_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an productCategory from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the productCategory ID to be deleted.
   * @param {number} payload.id - The ID of the productCategory to be deleted.
   * @return {void}
   */
  SET_DELETE_PRODUCT_CATEGORY(state, payload) {
    state.productCategories.data = state.productCategories.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_PRODUCT_CATEGORY_BY_ID_STATUS(state, payload) {
    state.productCategoryById.status = payload;
  },
  SET_PRODUCT_CATEGORY_BY_ID(state, payload) {
    state.productCategoryById.data.push(payload);
  },
  SET_PRODUCT_LIST_BY_CATEGORY(state, payload) {
    const index = state.productCategories.data.findIndex(
      (d) => d.id === payload.id
    );
    if (index > -1)
      state.productCategories.data[index].productList = payload.productList;
  },
};

const actions = {
  /**
   * Retrieves a list of productCategories based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.searchKey - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getProductCategories({ state, commit }, payload) {
    // if query param is not in payload or if there is already data with same page number, don't fetch again
    if (
      !["search"].some((key) => payload.query[key]) &&
      state.productCategories.data.filter(
        (productCategory) => productCategory.page === payload.query.page
      ).length > 0 &&
      !payload.force
    )
      return;
    const status = state.productCategories.status;
    commit("SET_PRODUCT_CATEGORY_STATUS", "loading");
    const response = await Requests.ProductCategory.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_PRODUCT_CATEGORIES", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page,
          productList: [],
        })),
        count: response.data.count,
      });
      if (status === "unitiliazed")
        commit("SET_ALL_PRODUCT_CATEGORIES", {
          items: response.data.items.map((item) => ({
            ...item,
            page: payload.query.page,
            productList: [],
          })),
          count: response.data.count,
        });
    }
    commit("SET_PRODUCT_CATEGORY_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an productCategory by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the productCategory data.
   * @param {string} payload.fullName - The full name of the productCategory.
   * @param {string} payload.phoneNumber - The phone number of the productCategory.
   * @param {string} payload.email - The email of the productCategory.
   * @param {string} payload.regionId - The ID of the region the productCategory belongs to.
   * @param {File} payload.image - The image of the productCategory.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createProductCategory({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.ProductCategory.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_PRODUCT_CATEGORY", {
          id: response.data,
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          email: payload.email,
          regionId: payload.regionId,
          image: payload.image,
          workStartTime: payload.workStartTime,
          workEndTime: payload.workEndTime,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an productCategory by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the productCategory data to update.
   * @param {string} payload.fullName - The full name of the productCategory.
   * @param {string} payload.phoneNumber - The phone number of the productCategory.
   * @param {string} payload.email - The email of the productCategory.
   * @param {string} payload.regionId - The ID of the region the productCategory belongs to.
   * @param {File} payload.image - The image of the productCategory.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @param {boolean} payload.isActive - Whether the productCategory is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateProductCategory({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.ProductCategory.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_PRODUCT_CATEGORY", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
      return response.message;
    } catch {
      state.updateStatus = "error";
      return "FAIL";
    }
  },
  /**
   * Removes an productCategory from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the productCategory data.
   * @param {number} payload.id - The ID of the productCategory to be removed.
   * @returns {Promise<void>} A promise that resolves when the productCategory is successfully removed.
   */
  removeProductCategory({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.ProductCategory.Delete({ id })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
      })
      .catch(() => {
        state.deleteStatus = "error";
      });
  },
  /**
   * Retrieves an productCategory by their ID and updates the productCategory by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the productCategory to retrieve.
   * @return {Promise} A promise that resolves when the productCategory is successfully retrieved and the status is updated.
   */
  getProductCategoryById({ commit, state }, { id }) {
    // check if productCategory already exists in the state;
    if (
      state.productCategoryById.data.find(
        (productCategory) => productCategory.id === id
      )
    )
      return state.productCategoryById.data.find(
        (productCategory) => productCategory.id === id
      );
    commit("SET_PRODUCT_CATEGORY_BY_ID_STATUS", "loading");
    return Requests.ProductCategory.GetById({ params: { id } })
      .then((response) => {
        commit("SET_PRODUCT_CATEGORY_BY_ID", response.data);
        commit("SET_PRODUCT_CATEGORY_BY_ID_STATUS", "success");
        return response.data;
      })
      .catch(() => {
        commit("SET_PRODUCT_CATEGORY_BY_ID_STATUS", "error");
        return null;
      });
  },
};

export default { state, getters, mutations, actions };
